<template>
  <div class="bk bk-loading-overlay" :class="{ 'bk-is-screen': screen }">
    <Icon name="spinner" />
  </div>
</template>

<script setup>
import { Icon } from "#blokkli/components";
defineProps({
  screen: { type: Boolean, required: false }
});
</script>

<script>
export default {
  name: "Loading"
};
</script>
